import React, { type FC } from 'react';

import { getColor } from '@lucid/theme';

import type { Lucid } from '../../types/types';

type ColorizeTextProps = {
  as?: 'div' | 'span';
  /** The text to parse */
  text?: string;
  /** Determines the color of the highlighted text section */
  highlightTextColor?: Lucid.Theme.Color.ValueKeys;
};

/** Looking for `{{string}}` to change the colored text */
const textMatch = /({{.*?}})|([^{{]+)(?={{|$)/g;
const isHighlightedText = /\{\{(.*?)\}\}/g;

const ColorizeText: FC<ColorizeTextProps> = ({ text, highlightTextColor }) => {
  const textArray = text?.match(textMatch);

  const colorizedText = textArray?.map((part, index) => {
    if (part?.match(isHighlightedText)) {
      return (
        <span
          key={`colorize-text-${index}`}
          css={theme => ({
            color: getColor({
              color: highlightTextColor,
              theme,
            }),
          })}
          // eslint-disable-next-line @stylistic/jsx-sort-props
          className="colorizedText"
          data-testid="colorizedText"
        >
          {part.replace('{{', '').replace('}}', '')}
        </span>
      );
    }

    return (
      <span key={`colorize-text-${index}`} className="nonColorizedText" data-testid="nonColorizedText">
        {part}
      </span>
    );
  });

  return colorizedText;
};

export default ColorizeText;
